export default "__VITE_ASSET__49de5c11__"